import { SuggestiveDropdown } from '@ahc-digital/component-library';
import { C10SuggestiveDropdownListProps } from './C10SuggestiveDropdownList.types';
import { CreateSuggestiveDropDownListModel } from './C10SuggestiveDropdownList.service';
import { translationClasses } from 'src/shared/TranslationClasses';

import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C10SuggestiveDropdownListProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <SuggestiveDropdown
      {...CreateSuggestiveDropDownListModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};
